import type { Row } from '@tanstack/react-table';
import type { AssignmentListRowData, UpsertWala } from './types';
import { StatusVersionBanner } from './StatusVersionBanner';
import { CardIncidentName } from './CardIncidentName';
import { CardOperationalPeriod } from './CardOperationalPeriod';
import { CardAssignedLocation } from './CardAssignedLocation';
import { CardOperations } from './CardOperations';
import { CardResources } from './CardResources';
import { CardWorkAssignments } from './CardWorkAssignments';
import { CardSpecialInstructions } from './CardSpecialInstructions';
import { CardCommunications } from './CardCommunications';
import { CardEmergencyCommunications } from './CardEmergencyCommunications';
import { CardPreparedBy } from './CardPreparedBy';
import { CardReviewedByPSC } from './CardReviewedByPSC';
import { CardReviewedByOSCISC } from './CardReviewedByOSCISC';

type AssignmentListItemProps = {
  row: Row<AssignmentListRowData>;
  upsertWala: UpsertWala;
  canEditCards: boolean;
  operationalPeriodId: string;
  periodNumber: number;
};

function AssignmentListItem({
  row,
  upsertWala,
  canEditCards,

  operationalPeriodId,
  periodNumber,
}: AssignmentListItemProps) {
  return (
    <div className="tw:grid tw:gap-5">
      <StatusVersionBanner timestamp={row.original.timestamp} />

      {/* Section 1 - 3 */}
      <div className="tw:flex tw:gap-4">
        <CardIncidentName />
        <CardOperationalPeriod periodNumber={periodNumber} />
        <CardAssignedLocation
          row={row}
          upsertWala={upsertWala}
          canEditCards={canEditCards}
        />
      </div>

      {/* Section 4 */}
      <CardOperations
        row={row}
        upsertWala={upsertWala}
        canEditCards={canEditCards}
      />

      {/* Section 5 */}
      <CardResources
        row={row}
        canEditCards={canEditCards}
        periodNumber={periodNumber}
      />

      {/* Section 6 */}
      <CardWorkAssignments row={row} />

      {/* Section 7 */}
      <CardSpecialInstructions
        row={row}
        upsertWala={upsertWala}
        canEditCards={canEditCards}
      />

      {/* Section 8 */}
      <CardCommunications
        row={row}
        upsertWala={upsertWala}
        canEditCards={canEditCards}
      />

      <CardEmergencyCommunications
        row={row}
        upsertWala={upsertWala}
        canEditCards={canEditCards}
      />

      {/* Section 9 - 11 */}
      <CardPreparedBy />
      <CardReviewedByPSC />
      <CardReviewedByOSCISC />
    </div>
  );
}

export default AssignmentListItem;
